
module dg.objects {

    function percent($filter: ng.IFilterService): ng.IDirective {
        return {
            restrict: 'A',
            require: ['ngModel'],
            template: '<input type="text" class="form-control" />',
            replace: true,
            compile: (tElement, tAttr, transclude) => {
                return (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrls) => {
                    var ngModel: ng.INgModelController = ctrls[0];
                    ngModel.$formatters.push((value: number) => {
                        return value * 100;
                    });
                    ngModel.$parsers.push((value: number) => {
                        return value / 100;
                    });
                };
            }
        };
    }

    angular.module('dg.objects')
        .directive('percent', percent);
} 
